import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  // Check if the user is authenticated
  if (!token) {
    // If no token, redirect to login page
    return <Navigate to="/login" />;
  }

  // If authenticated, render the children (the protected page)
  return children;
};

export default PrivateRoute;
